import React from 'react'

export default function SpeechBubble(props) {
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.99 2c0-1.1-.89-2-1.99-2H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM16 12H4v-2h12v2zm0-3H4V7h12v2zm0-3H4V4h12v2z"
          fill="#0A4BB8"
          fillRule="nonzero"
        />
        <path d="M-2-2h24v23.999H-2z" />
      </g>
    </svg>
  )
}
